import { type CollectionConfig, CollectionLayout, CollectionSlug } from '../collections.types';

const IMAGES = 'https://p1.liveauctioneers.com/dist/images/traditional-n-antique-furniture-and-decor';

export const traditionalAntiqueCollection: CollectionConfig = {
    breadcrumbs: [
        { href: '/c/furniture/', label: 'Furniture' },
        { href: '', label: 'Traditional & Antique' },
    ],
    description:
        'Shop classic pieces from Baker Furniture, Ralph Lauren and Federal Furniture makers, plus equestrian, English decorative arts and blue and white styles.',
    layout: CollectionLayout.Collection,
    metaDescription:
        'Shop traditional and antique furniture and decor at auction — Baker Furniture, Ralph Lauren, Federal furniture, equestrian art, English decorative arts and blue and white from top auction houses.',
    searchParams: { keyword: 'english', sale_type: 'liveAuction', status: 'online' },
    seoTitle: 'Traditional & Antique Furniture and Decor for Sale at Auction',
    slug: CollectionSlug.TraditionalAntique,
    subcategories: [
        {
            href: '/search/?keyword=baker%20furniture&status=online',
            imageUrl: `${IMAGES}-baker-furniture.png`,
            title: 'Baker Furniture',
        },
        {
            href: '/search/?category_id=5&keyword=english&status=online',
            imageUrl: `${IMAGES}-english-decorative-arts.png`,
            title: 'English Decorative Arts',
        },
        {
            href: '/search/?keyword=equestrian&status=online',
            imageUrl: `${IMAGES}-equestian.png`,
            title: 'Equestrian',
        },
        {
            href: '/search/?keyword=ralph%20lauren&status=online',
            imageUrl: `${IMAGES}-ralph-lauren.png`,
            title: 'Ralph Lauren',
        },
        {
            href: '/search/?category_id=5&keyword=blue%20and%20white&status=online',
            imageUrl: `${IMAGES}-blue-n-white.png`,
            title: 'Blue & White',
        },
        {
            href: '/search/?keyword=federal%20furniture&page=2',
            imageUrl: `${IMAGES}-federal-furniture.png`,
            title: 'Federal Furniture',
        },
    ],
    title: 'Traditional & Antique Furniture and Decor',
};
